<template>
  <main-toolbar >
    <div class="sales-select-box-wrapper">
      <search-select-auto-complete
          :items="companyOptions"
          :label="'업체번호' | translate"
          class="sales-select-box-style"
          v-model="innerValue.rentalcompanyId"
      />
      <search-select-auto-complete
          :items="accountOptions"
          :label="'거래처번호' | translate"
          class="sales-select-box-style"
          v-model="innerValue.accountId"
      />
      <select-box-multi-check
          :items="billDayOnlyNumberOptions"
          :label="'결제일' | translate"
          class="sales-select-box-style"
          v-model="innerValue.billDayList"
      />
      <select-box-multi-check
          :items="billDayOnlyNumberOptions"
          :label="'계산시작일' | translate"
          class="sales-select-box-style"
          v-model="innerValue.calculationStartdateList"
      />
      <select-box-multi-check
          :items="billDayOnlyNumberOptions"
          :label="'세금계산서발행일' | translate"
          class="sales-select-box-style"
          v-model="innerValue.taxSchDayList"
      />
      <select-box-multi-check
          :items="billDayOnlyNumberOptions"
          :label="'거래명세표발행일' | translate"
          class="sales-select-box-style"
          v-model="innerValue.statementIssueDayList"
      />
      <select-box-multi-check
          :items="useYnOptions"
          :label="'거래상태' | translate"
          class="sales-select-box-style"
          v-model="innerValue.useYnList"
      />
      <select-box-single-check
          :items="deleteYnOptions"
          :label="'삭제여부' | translate"
          class="sales-select-box-style"
          v-model="innerValue.deleteYn"
      />
      <select-box-single-check
          :items="taxYnOptions"
          :label="'거래처약정여부' | translate"
          class="sales-select-box-style"
          v-model="innerValue.contractFeeYn"
      />
      <select-box-single-check
          :items="taxYnOptions"
          :label="'미납금액재출금여부' | translate"
          class="sales-select-box-style"
          v-model="innerValue.unpaidRequestYn"
      />
      <select-box-single-check
          :items="taxYnOptions"
          :label="'자동화-매출' | translate"
          class="sales-select-box-style"
          v-model="innerValue.autoUseYn"
      />
      <select-box-single-check
          :items="taxYnOptions"
          :label="'자동화-CMS' | translate"
          class="sales-select-box-style"
          v-model="innerValue.autoUseCmsYn"
      />
      <select-box-single-check
          :items="taxYnOptions"
          :label="'자동화-세금계산서' | translate"
          class="sales-select-box-style"
          v-model="innerValue.autoUseTaxYn"
      />
      <select-box-single-check
          :items="taxYnOptions"
          :label="'자동화-거래명세표' | translate"
          class="sales-select-box-style"
          v-model="innerValue.autoUseStatementYn"
      />

    </div>
  </main-toolbar>
</template>

<script>

import MainToolbar from "@/components/common/layout/MainToolbar";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
import SelectBoxSingleCheck from "@/components/selectBox/SelectBoxSingleCheck";
import SelectBoxMultiCheck from "@/components/selectBox/SelectBoxMultiCheck";
import {PATH} from "@/constants";
import SearchSelectAutoComplete from "@/components/selectBox/SearchSelectAutoComplete";

export default {
  name: "SearchGroupSales",
  mixins: [TotalCodeOptions],
  data() {
    return{
      innerValue: undefined,
      accountOptions:[]
    }
  },
  props: {
    selectOptions:{
      type:Object
    },
  },
  components:{
    MainToolbar,
    SelectBoxSingleCheck,
    SelectBoxMultiCheck,
      SearchSelectAutoComplete
  },
  created() {
    /**
     * 필더 목록 가져오는 함수
     * TotalCodeOptions.vue 참고
     *
     * 1.loadCompanyOptions()
     * 필터 종류 : rentalcompanyId
     * optionsArr :companyOptions
     * key : 임대업체 코드, value: 임대업체명
     *
     * 2.loadBillDayOnlyNumberOptions()
     * 필터 종류 : billDay, calculationStartdate, taxSchDay, statementIssueDay
     * optionsArr : billDayOnlyNumberOptions
     * key, value : 1~31
     *
     * 3.this.loadUseYnOptions()
     * 필터 종류 : useYn
     * optionsArr : useYnOptions
     * key : C , Y , N , value : 일시정지, 계약중, 계약해지
     *
     * 4.loadTaxYnOptions()
     * 필터 종류 :
     * contractFeeYn
     * unpaidRequestYn
     * autoUseYn
     * autoUseCmsYn
     * autoUseTaxYn
     * autoUseStatementYn
     * optionsArr : taxYnOptions
     *key : Y , N , value : 사용, 미사용
     *
     * 5.loadDeleteYnOptions()
     * 필터 종류 :
     * deleteYn
     * optionsArr : deleteYnOptions
     * key : Y , N , value : 삭제, 사용중
     *
     */

    this.loadCompanyOptions();
    this.loadBillDayOnlyNumberOptions();
    this.loadUseYnOptions();
    this.loadTaxYnOptions();
    this.loadDeleteYnOptions();
  },
  watch: {
    selectOptions:{
        deep:true,
      immediate: true,
      handler(newValue) {
        this.innerValue = newValue
      }
    },
    innerValue: {
      deep: true,
      immediate: true,
      handler(newValue){
          this.$emit('update:select-options',newValue)
      }
    },
    'innerValue.rentalcompanyId'(){
      /**
       * 업체번호 필터에 있는 부분 선택시
       * 거래처 번호 옵션 목록 api 호출
       */
      this.loadAccountOptions(this.innerValue.rentalcompanyId)
    }

  },
  methods :{
    /***
     *
     * @param rentalcompanyId
     * @returns void
     * 거래처 번호 select 박스 옵션 데이터 가져오는 부분입니
     */
    async loadAccountOptions(rentalcompanyId) {
        if(!rentalcompanyId) { //업체번호가 없을 경우 요청을 보내지 않습니다.
            this.accountOptions=[]
            return;
        }
      await this.$request(`${PATH.ACCOUNT.LIST}/${rentalcompanyId}`)
          .get()
          .catch(e => {
            alert('조회실패')
          })
          .enqueue()
          .then(res => {
            const accountArr = res.data.map((
                {account_id, account_name}) => {
              return {codeKey: account_id, codeValue: account_name}
            })
            this.accountOptions=[...accountArr]
          });
    },
  }


}
</script>

<style scoped>
.sales-select-box-wrapper{
  display: flex;
  width: 100%;

}
.sales-select-box-style{
  width: 180px;
  margin: 2px
}
.main-toolbar[data-v-6772237e]{
  margin-bottom:0px
}

>>> .v-input__control{
  width: 10px;
  height: 10px;
}
/* Select Box 에서 height부분 */
>>> .v-input__control .v-input__slot  fieldset{
  height: 47px;
}
/* Select Box 에서 X 아이콘 font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-input__append-inner .v-icon {
  font-size: 19px;
}

/* Select Box 에서 label font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-label {
  font-size: 12px;
}

>>> .v-input__control  .v-input__slot  .v-select__slot  .v-select__selections {
  padding: 0;
}
/*single Select Box 에서 font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-select__selections .v-select__selection {
  font-size: 12px;
  margin: 0;
}
/*Multi Select Box 에서 font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-select__selections .text-truncate {
  font-size: 12px;
  margin: 0;
}
/*SearchSelectBox 에서 font 부분입니다.*/
>>> .v-select.v-text-field input {
    font-size: 12px !important;
    margin: 0 !important;
}

</style>